import { render } from "./TemplateRoutes.vue?vue&type=template&id=580e04f4"
import script from "./TemplateRoutes.vue?vue&type=script&lang=js"
export * from "./TemplateRoutes.vue?vue&type=script&lang=js"

import "./TemplateRoutes.vue?vue&type=style&index=0&id=580e04f4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__